var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.5H11C11.5523 2.5 12 2.94772 12 3.5V7.49385H10.7139L9.74091 5.16145C9.65299 4.94445 9.43627 4.81565 9.20191 4.82153C9.08789 4.82774 8.97849 4.86867 8.8884 4.93884C8.79832 5.00901 8.73185 5.10506 8.69791 5.21409L7.40879 9.42753L5.70947 3.71973C5.67457 3.60636 5.60485 3.50686 5.51021 3.43534C5.41558 3.36382 5.30082 3.32392 5.18223 3.32129C4.94171 3.32717 4.71911 3.47361 4.64295 3.70209L3.39471 7.48769H2.07031C2.04667 7.48783 2.02319 7.48947 2 7.49254V3.5C2 2.94772 2.44772 2.5 3 2.5ZM2 8.59654V11.5C2 12.0523 2.44772 12.5 3 12.5H11C11.5523 12.5 12 12.0523 12 11.5V8.60713H10.3449C10.2352 8.60668 10.128 8.57429 10.0364 8.51393C9.94481 8.45357 9.87278 8.36784 9.82911 8.26721L9.30187 7.01897L7.92455 11.5253C7.888 11.6367 7.81747 11.7339 7.72286 11.8032C7.62824 11.8725 7.5143 11.9105 7.39703 11.9117C7.27718 11.9113 7.16065 11.8723 7.06465 11.8005C6.96865 11.7288 6.89827 11.6281 6.86391 11.5132L5.14107 5.74133L4.32655 8.22017C4.28993 8.33111 4.21921 8.42765 4.12449 8.49603C4.02976 8.56441 3.91586 8.60114 3.79903 8.60097H2.07031C2.04675 8.60098 2.02327 8.5995 2 8.59654ZM1 3.5C1 2.39543 1.89543 1.5 3 1.5H11C12.1046 1.5 13 2.39543 13 3.5V11.5C13 12.6046 12.1046 13.5 11 13.5H3C1.89543 13.5 1 12.6046 1 11.5V3.5Z",
    fill: "#848491"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.94b130b0b2a639cc1430339c2bca4f02.svg";
export { ForwardRef as ReactComponent };